<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <p class="body-2 grey--text text--darken-1">{{ $t('ESTIMATE_NEW_HINT') }}</p>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
          rules="required"
          vid="propagandist"
          :name="$t('fields.propagandist').toLowerCase()"
          v-slot="{ errors }"
        >
          <PropagandistSelect
            v-model="form.propagandist_id"
            :label="$t('fields.propagandist')"
            :errors="errors"
          ></PropagandistSelect>
        </ValidationProvider>
      </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('ESTIMATE_GENERATE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import PropagandistSelect from '../../shared/Vselects/PropagandistSelect.vue';

  export default {
    name: 'EstimateModal',
    components: {
      PropagandistSelect,
    },
    data() {
      return {
        form: {
          propagandist_id: null,
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (!isValid || !this.options.onSave) {
          return;
        }
        this.loadingModal(true);
        this.options.onSave(this.form, this.errors)
          .then(() => {
            this.loadingModal(false);
          })
          .catch(error => {
            this.handleError(error, this.errors);
          });
      },
      cancel() {
        this.hideModal({});
      },
    },
  };
</script>
